import { jsxs as l, jsx as h } from "react/jsx-runtime";
const r = (v) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...v,
    children: [
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M22.804 31.99h-1.998v16.189h1.998V31.99ZM32.998 31.99H31v16.104h1.998V31.99ZM48.979 39.942c1.369 0 2.841.481 3.938 1.287 1.283.942 1.961 2.285 1.961 3.885 0 1.6-1.177 3.712-3.314 6.169a35.57 35.57 0 0 1-2.595 2.667 33.308 33.308 0 0 1-2.578-2.61c-2.134-2.428-3.31-4.639-3.31-6.226 0-1.706.638-2.994 1.949-3.939 1.072-.772 2.548-1.233 3.949-1.233Zm0-3c-2.037 0-4.116.656-5.702 1.798-2.091 1.506-3.196 3.71-3.196 6.374 0 2.382 1.365 5.143 4.056 8.206a35.313 35.313 0 0 0 3.857 3.756l.999.809h.001l.987-.822c.078-.066 1.951-1.634 3.846-3.81 2.687-3.09 4.051-5.827 4.051-8.138 0-2.556-1.131-4.794-3.185-6.303a9.864 9.864 0 0 0-5.714-1.869v-.001Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "m50.586 45.098-.477-1.782-.128-.478-.479.129-1.782.477-.478.128.128.477.477 1.782.128.477.479-.128 1.781-.478.479-.128-.128-.477v.001ZM42.107 37.117c.281-.203.577-.391.881-.567v-4.56H40.99v6.06c.344-.333.716-.644 1.117-.933Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fill: "currentColor",
          d: "M42.634 54.64a29.981 29.981 0 0 1-.567-.664H16.002V32.029h-5.977v-6.001h43.951v6.001h-4.053v2.954c1.339.115 2.678.469 3.911 1.027h4.139V22.033h-5.757L45.55 7.085h-6.715v-.999H25.166v.999h-6.502l-6.859 14.948h-1.776a4 4 0 0 0-4 4v6.015a4 4 0 0 0 4 4h1.977v17.924a4 4 0 0 0 4 4h29.959a38.207 38.207 0 0 1-3.331-3.333v.001ZM19.99 9.081h5.175v.999h13.669v-.999h5.375l5.847 12.951H13.973l6.016-12.951h.001Z"
        }
      )
    ]
  }
);
export {
  r as StoreLocator
};
